import { type TranslationTree } from '@/i18n/types';

export const messages = {
  canceledTitle: 'Cancelado em {{date}}',
  canceled: 'O evento saiu do app. Quem confirmou vê o evento como cancelado.',
  inReviewTitle: 'Em análise desde {{date}}',
  inReviewTitleNoDate: 'Em análise',
  inReview: 'A Bodyprint costuma responder em até 2 dias úteis. Editar mantém o evento na fila.',
  rejectedTitle: 'Recusado pela Equipe Bodyprint',
  rejectedNoNote: 'Revise os dados do evento e envie de novo.',
  approved: 'Publicado no app. Editar tira o evento do app até uma nova aprovação.',
} satisfies TranslationTree;
